import { useState } from "react";

import { downloadReport } from "./download";
import type { ReportDoc } from "./pdf/model";

/**
 * "↓ PDF report": the run or the bot as a printable document — headline
 * numbers, equity and drawdown, the rules and every trade.
 */
export function ReportPdfButton({
  build,
  label = "PDF report",
  size = "sm",
  disabled = false,
}: {
  /** Builds the report at click time, from whatever the page holds then. */
  build: () => ReportDoc | null | Promise<ReportDoc | null>;
  label?: string;
  size?: "sm" | "md";
  disabled?: boolean;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function run() {
    setBusy(true);
    setError(null);
    try {
      const report = await build();
      if (report) await downloadReport(report);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="export-menu">
      <button
        type="button"
        className={`btn${size === "sm" ? " btn--sm" : ""}`}
        disabled={busy || disabled}
        title="Download a printable PDF report"
        onClick={() => void run()}
      >
        {busy ? "Building PDF…" : `↓ ${label}`}
      </button>
      {error && (
        <span className="export-menu__error" role="alert">
          Couldn't build the PDF: {error}
        </span>
      )}
    </div>
  );
}
